<template>
  <div class="components_warp">
    <div class="top-container">
      <div v-for="(topic, index) in topics" :key="index">
        <div v-if="index == curIndex">
          <div class="img-warp">
            <div
              style="
                width: 400px;
                height: 300px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <div class="setImg">
                 +
              </div>
              <img :src="topic.img" alt="表情" class="hideImg" style="display: none"/>
            </div>
          </div>
          <div :class="type=='test'?'':'hideImg'">
            <section class="light ">
              <label v-for="(t, index) in topic.options" :key="index">
                <input
                    class="radio_btn"
                    type="radio"
                    name="light"
                    v-model="radioVal"
                    :value="t.optOrder"
                    @change="name == 'test'?'':next()"
                />
                <span class="design"></span>
                <span class="text">{{ letterArr[index] }} {{ t.optTxt }}</span>
              </label>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div class="hides">
      <div class="btn_warp " v-if="name == 'test'">
        <p :style="{color:color,width:'81px',whiteSpace:'nowrap'}">{{content}}</p>
        <span></span>
        <button @click="next2" style="position: relative;left:-20px">确定</button>
        <span
        ><em>{{ curIndex + 1 }}</em
        >/{{ topics.length }}</span
        >
      </div>
      <div class="btn_warp " v-else>
        <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
        <span></span>
        <!--      <button @click="next">确定</button>-->
        <span
        ><em>{{ curIndex + 1 }}</em
        >/{{ topics.length }}</span
        >
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      curIndex: 0,
      topics: [],
      radioVal: "",
      answers: [],
      tempTime: "",
      questionId: "",
      startTime:"",
      nowTime:"",
      name: this.$route.query.name,
      letterArr: ["A、", "B、", "C、", "D、", "E、", "F、", "G、", "H、", "I、"],
      letterArrs: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
      isArr: ["1", "2", "3", "4", "5"],
      url2: {
        path: "/careerevalution/guide",
        query: { name: "znsp", part: "znsp71" },
      },
      url: {
        path: "/careerevalution/home",
        query: { name: "znsp", part: "znsp81" },
      },
      number:10,
      content:'',
      color:'',
      bool:true,
      oldTime:'',
      submitBool:true
    };
  },
  created() {
    // this.getTopicApi();
  },
  mounted() {
    if (this.name == "test") {
      this.getTopicSplice();
      sessionStorage.setItem("kongTest71", 1);
    } else {
      this.startTime = new Date().getTime();
      this.nowTime=new Date().getTime()
      this.getTopicApi();
      setInterval(()=>{
        this.number--;
        if(this.number==0){
          this.tempTime = new Date().getTime()-this.nowTime;
          if (this.radioVal == 1) {
            this.answers.push({
              questionId: this.topics[this.curIndex].id,
              time: this.tempTime,
              answer: "A",
            });
          } else if (this.radioVal == 2) {
            this.answers.push({
              questionId: this.topics[this.curIndex].id,
              time: this.tempTime,
              answer: "B",
            });
          } else if (this.radioVal == 3) {
            this.answers.push({
              questionId: this.topics[this.curIndex].id,
              time: this.tempTime,
              answer: "C",
            });
          } else if (this.radioVal == 4) {
            this.answers.push({
              questionId: this.topics[this.curIndex].id,
              time: this.tempTime,
              answer: "D",
            });
          }else if (this.radioVal == 5) {
            this.answers.push({
              questionId: this.topics[this.curIndex].id,
              time: this.tempTime,
              answer: "E",
            });
          }else{
            this.answers.push({
              questionId: this.topics[this.curIndex].id,
              time: this.tempTime,
              answer: "",
            })
          }
          this.nowTime=new Date().getTime()
          this.radioVal = "";

          if (this.curIndex + 1 < this.topics.length) {
            this.curIndex++;
            $('.hides').hide()
            this.number=10
            setTimeout(()=>{
              $('.setImg').hide()
              $('.hideImg').show()
              $('.hides').show()
            },1000)
          } else {
            if(!this.submitBool){
              return;
            }
            this.saveNode(2, 81, () => {
              this.submit();
            });
          }
        }

      },1000)
    }
  },
  methods: {
    getTopicSplice() {
      this.topics = [
        {
          id: 1,
          img: "./imgs/careerEvaluation/test_xiyue.jpg",
          name: "情绪识别1",
          options: [
            { optImg: "", optTxt: "喜悦", optOrder: 1 },
            { optImg: "", optTxt: "惊恐", optOrder: 2 },
            { optImg: "", optTxt: "悲伤", optOrder: 3 },
            { optImg: "", optTxt: "愤怒", optOrder: 4 },
            { optImg: "", optTxt: "平静", optOrder: 5 },
          ],
        },
        {
          id: 2,
          img: "./imgs/careerEvaluation/test_jingju.jpg",
          name: "情绪识别1",
          options: [
            { optImg: "", optTxt: "喜悦", optOrder: 1 },
            { optImg: "", optTxt: "惊恐", optOrder: 2 },
            { optImg: "", optTxt: "悲伤", optOrder: 3 },
            { optImg: "", optTxt: "愤怒", optOrder: 4 },
            { optImg: "", optTxt: "平静", optOrder: 5 },
          ],
        },
        {
          id: 1,
          img: "./imgs/careerEvaluation/test_beishang.jpg",
          name: "情绪识别1",
          options: [
            { optImg: "", optTxt: "喜悦", optOrder: 1 },
            { optImg: "", optTxt: "惊恐", optOrder: 2 },
            { optImg: "", optTxt: "悲伤", optOrder: 3 },
            { optImg: "", optTxt: "愤怒", optOrder: 4 },
            { optImg: "", optTxt: "平静", optOrder: 5 },
          ],
        },
        {
          id: 1,
          img: "./imgs/careerEvaluation/test_fennu.jpg",
          name: "情绪识别1",
          options: [
            { optImg: "", optTxt: "喜悦", optOrder: 1 },
            { optImg: "", optTxt: "惊恐", optOrder: 2 },
            { optImg: "", optTxt: "悲伤", optOrder: 3 },
            { optImg: "", optTxt: "愤怒", optOrder: 4 },
            { optImg: "", optTxt: "平静", optOrder: 5 },
          ],
        },
        {
          id: 1,
          img: "./imgs/careerEvaluation/test_pingjing.jpg",
          name: "情绪识别1",
          options: [
            { optImg: "", optTxt: "喜悦", optOrder: 1 },
            { optImg: "", optTxt: "惊恐", optOrder: 2 },
            { optImg: "", optTxt: "悲伤", optOrder: 3 },
            { optImg: "", optTxt: "愤怒", optOrder: 4 },
            { optImg: "", optTxt: "平静", optOrder: 5 },
          ],
        },
      ];
      setTimeout(()=>{
        setTimeout(()=>{
          $('.setImg').hide()
          $('.hideImg').show()
          $('.hides').show()
        },1000)
      },1000)
    },
    getTopicApi() {
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.rjnlList4}`,
          {},
          {
            headers: {
              token: sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.topics = res.data.data;
          this.$nextTick(()=>{
            setTimeout(()=>{
              $('.setImg').hide()
              $('.hideImg').show()
              $('.hides').show()
            },1000)
          })
          console.log(this.topics);
        });
    },
    next2() {
      if (this.radioVal == "") {
        this.$message.error("请选择答案");
        return false;
      }
      if(this.bool){
        this.bool=false
        if (this.radioVal == this.isArr[this.curIndex]) {
          this.content='作答正确！'
          this.color='#67C23A'
        } else {
          this.content='作答错误，正确答案是'+this.letterArrs[this.curIndex]
          this.color='red'
          // this.radioVal = this.isArr[this.curIndex]
        }
      }else{
        this.bool=true
        this.content=''
        if (this.curIndex + 1 < this.topics.length) {
          this.curIndex++;
          this.radioVal = "";
          $('.hides').hide()
          setTimeout(()=>{
            $('.setImg').hide()
            $('.hideImg').show()
            $('.hides').show()
          },1000)

        } else {
          this.$router.push({
            path: "/careerevalution/success",
            query: {
              type: "test",
              url: this.url2,
            },
          });
        }
      }

    },
    next() {
      if (this.radioVal == "") {
        this.$message.error("请选择答案");
        return false;
      }

      this.tempTime = new Date().getTime()-this.nowTime;
      if (this.radioVal == 1) {
        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: this.tempTime,
          answer: "A",
        });
      } else if (this.radioVal == 2) {
        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: this.tempTime,
          answer: "B",
        });
      } else if (this.radioVal == 3) {
        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: this.tempTime,
          answer: "C",
        });
      } else if (this.radioVal == 4) {
        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: this.tempTime,
          answer: "D",
        });
      }else if (this.radioVal == 5) {
        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: this.tempTime,
          answer: "E",
        });
      }
      this.nowTime=new Date().getTime()
      this.radioVal = "";

      if (this.curIndex + 1 < this.topics.length) {
        this.curIndex++;
        this.number=10;
        $('.hides').hide()
        setTimeout(()=>{
          $('.setImg').hide()
          $('.hideImg').show()
          $('.hides').show()
        },1000)
      } else {
        this.submitBool=false
        this.saveNode(2, 81, () => {
          this.submit();
        });
      }
    },
    submit() {
      //提交
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.rjnlAdd4}`,
          {
            testId: sessionStorage.getItem("testId"),
            time: new Date().getTime()-this.startTime,
            answers: this.answers,
          },
          {
            headers: {
              token: sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          var data = res.data;
          if (data.code == 2000) {
            this.$router.push({
              path: "/careerevalution/success",
              query: {
                type: "answer",
                url: this.url,
              },
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.components_warp {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
ul {
  overflow: hidden;
  display: flex;
  justify-content: center;
}
ul li {
  float: left;
}
ul li p {
  text-align: center;
  margin-top: 15px;
}
.img-warp {
  margin-top: 30px;
}
.title {
  text-align: center;
}
.title h4 {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.text_bewrite {
  margin: 30px 0 0px 0;
}
.text_bewrite p {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.icon_warp span {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #f81818;
}
.img-warp {
  display: flex;
  justify-content: center;
}
.btn_warp {
  /* width: 70%;
    text-align: center;
    position: absolute;
    bottom:70px; */
  display: flex;
  justify-content: space-between;
}
/* 按钮 */
.btn_warp button {
  width: 166px;
  height: 41px;
  background: linear-gradient(90deg, #1fd99c 0%, #1ac6fd 100%);
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: 40px auto 0;
  display: block;
}

.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;
}

/* 单选按钮 */

.light {
  --primary: #29d3ec;
  --other: #29d3ec;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

.dark {
  --primary: hsl(1, 100%, 68%);
  --other: hsl(0, 0%, 90%);
  background: hsl(0, 0%, 10%);
}

/* h1 */
h1 {
  color: var(--other);
  padding: 8px 4px;
  border-bottom: 2px solid var(--other);
}

/* label */
label {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  width: 150px;
  margin: 12px 0;
  height: 40px;
  background: hsl(0, 0%, 98%);
  cursor: pointer;
  position: relative;
  border-radius: 8px;
}

/* input */
.radio_btn {
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: -1;
}

/* .design */
.design {
  width: 16px;
  height: 16px;
  border: 1px solid var(--other);
  border-radius: 100%;
  margin-right: 16px;
  position: relative;
}

.design::before,
.design::after {
  content: "";
  display: block;

  width: inherit;
  height: inherit;

  border-radius: inherit;

  position: absolute;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.design:before {
  background: var(--other);
  opacity: 0;
  transition: 0.3s;
}

.design::after {
  background: var(--primary);
  opacity: 0.4;
  transition: 0.6s;
}

/* .text */
.text {
  color: #333;
  /* font-weight: bold; */
}

/* checked state */
.radio_btn:checked + .design::before {
  opacity: 1;
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}

/* other states */
/* input:hover+.design,
  input:focus+.design {
    border: 1px solid var(--primary);
  }
  
  input:hover+.design:before,
  input:focus+.design:before {
    background: var(--primary);
  }
  
  input:hover~.text {
    color: var(--primary);
  } */
/*.radio_btn:focus + .design::after,*/
/*.radio_btn:active + .design::after {*/
/*  opacity: 0.1;*/
/*  -webkit-transform: scale(2.6);*/
/*  transform: scale(2.6);*/
/*}*/
  .setImg{
    width: 260px;
    height: 300px;
    border:1px solid #CBCACA;
    text-align: center;
    line-height: 300px;
    color:#1ED5B3;
    font-size:50px;
    box-sizing: border-box;
  }
 .hideImg{
   display: none;
 }
 .hides{
   display: none;
 }
</style>